import { Component, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Router, RouterLink } from "@angular/router";

import { ApiService } from "src/app/api.service";
import { FleetTrackerService } from "src/app/fleet-tracker.service";
import { GitVersionService } from "src/app/gitversion.service";
declare const BrandVars: any;

@Component({
	selector: "app-hamburger-menu",
	templateUrl: "./hamburger-menu.component.html",
	styleUrls: ["./hamburger-menu.component.scss"],
	imports: [RouterLink]
})
export class HamburgerMenuComponent {
	private router = inject(Router);
	private git = inject(GitVersionService);
	private fleettracker = inject(FleetTrackerService);
	public api = inject(ApiService);

	public brand = BrandVars;

	public menuShow = false;
	public clientVersion = "";
	public serverVersion = "";

	constructor() {
		this.git.Client.pipe(takeUntilDestroyed()).subscribe(version => {
			this.clientVersion = version;
		});
		this.git.Server.pipe(takeUntilDestroyed()).subscribe(version => {
			this.serverVersion = version;
		});
	}

	ToggleMenu() {
		this.menuShow = !this.menuShow;
	}

	Logout() {
		this.api.Logout();
		this.fleettracker.Clear();
		this.router.navigate(["login"]);
	}

}
